import React from 'react';

/**
 * Month-granularity range picker.
 *
 * Deliberately months, not days: discharges, attendance and length of stay
 * arrive from KIPU once per month per therapist, so a day-level picker would
 * imply a precision the underlying data does not have.
 *
 * Uses <input type="month">, which gives the native picker on every browser
 * the app supports and hands back a "YYYY-MM" string — exactly the format the
 * range endpoints parse.
 */
export default function MonthRangePicker({ from, to, onChange, max, disabled = false }) {
  const handleFrom = (value) => {
    // Dragging the start past the end is easier to fix for the user than it is
    // to reject, so push the end along with it.
    onChange({ from: value, to: value > to ? value : to });
  };

  const handleTo = (value) => {
    onChange({ from: value < from ? value : from, to: value });
  };

  const field = 'border border-gray-200 rounded-lg px-3 py-2.5 text-sm bg-white w-full sm:w-auto focus:outline-none focus:ring-2 focus:ring-primary-30 focus:border-primary-30 disabled:opacity-50';

  return (
    <div className="flex flex-col sm:flex-row sm:items-end gap-3">
      <div className="flex-1 sm:flex-none">
        <label htmlFor="range-from" className="block text-sm font-semibold text-gray-700 mb-1">From</label>
        <input
          id="range-from"
          type="month"
          value={from}
          max={max}
          disabled={disabled}
          onChange={(e) => e.target.value && handleFrom(e.target.value)}
          className={field}
        />
      </div>
      <div className="flex-1 sm:flex-none">
        <label htmlFor="range-to" className="block text-sm font-semibold text-gray-700 mb-1">To</label>
        <input
          id="range-to"
          type="month"
          value={to}
          max={max}
          disabled={disabled}
          onChange={(e) => e.target.value && handleTo(e.target.value)}
          className={field}
        />
      </div>
    </div>
  );
}
